var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarningTriangle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1052_76722)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99996 5.14288C8.31555 5.14288 8.57139 5.39872 8.57139 5.71431V9.14288C8.57139 9.45847 8.31555 9.71431 7.99996 9.71431C7.68437 9.71431 7.42853 9.45847 7.42853 9.14288V5.71431C7.42853 5.39872 7.68437 5.14288 7.99996 5.14288Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.8571 12.5715C6.8571 11.9403 7.36878 11.4286 7.99996 11.4286C8.63114 11.4286 9.14282 11.9403 9.14282 12.5715C9.14282 13.2026 8.63114 13.7143 7.99996 13.7143C7.36878 13.7143 6.8571 13.2026 6.8571 12.5715Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10587 0.258463C7.37506 0.0939079 7.68445 0.00683594 7.99996 0.00683594C8.31547 0.00683594 8.62486 0.0939079 8.89405 0.258463C9.16325 0.423018 9.38181 0.658672 9.52567 0.939475L9.5282 0.944473L15.8131 13.5143L15.8136 13.5152C15.9448 13.7759 16.0072 14.0659 15.995 14.3575C15.9828 14.6495 15.8961 14.9335 15.7432 15.1825C15.5904 15.4316 15.3764 15.6374 15.1216 15.7805C14.8668 15.9236 14.5796 15.9991 14.2874 16L14.2857 16H1.71425L1.71252 16C1.42029 15.9991 1.13314 15.9236 0.878344 15.7805C0.623544 15.6374 0.409549 15.4316 0.256681 15.1825C0.103814 14.9335 0.0171506 14.6495 0.00492025 14.3575C-0.00729878 14.0658 0.0551831 13.7758 0.186436 13.515L0.186802 13.5143L6.47172 0.944473L6.47425 0.939475C6.61811 0.658672 6.83667 0.423018 7.10587 0.258463ZM7.99996 1.14969C7.89479 1.14969 7.79166 1.17872 7.70193 1.23357C7.61286 1.28802 7.54041 1.36582 7.49245 1.45851L1.2082 14.027L1.2074 14.0286C1.16357 14.1156 1.1427 14.2123 1.14678 14.3097C1.15085 14.407 1.17974 14.5016 1.2307 14.5847C1.28165 14.6677 1.35298 14.7363 1.43792 14.784C1.52265 14.8316 1.61811 14.8568 1.71528 14.8572H14.2846C14.3818 14.8568 14.4773 14.8316 14.562 14.784C14.6469 14.7363 14.7183 14.6677 14.7692 14.5847C14.8202 14.5016 14.8491 14.407 14.8531 14.3097C14.8572 14.2123 14.8364 14.1156 14.7925 14.0286L14.7917 14.027L8.50747 1.45851C8.45951 1.36582 8.38706 1.28802 8.29799 1.23357C8.20826 1.17872 8.10513 1.14969 7.99996 1.14969Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1052_76722"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningTriangle);
export default __webpack_public_path__ + "static/media/warning-triangle.6a2b5b77cde5ee9cfdef6d165992f225.svg";
export { ForwardRef as ReactComponent };